"use client";
import { jsx } from "react/jsx-runtime";
import { ZIPCODE_QUERY_PARAM } from "../../../../utils/constants.js";
import "../../../Chrome/BrowseContext/ContextProvider.js";
import { useBrowseContext } from "../../../Chrome/BrowseContext/hook.js";
const SameDay = (props) => {
  const { deliveryLocation } = useBrowseContext();
  const { href, className } = props;
  const samedayLink = deliveryLocation.zipCode && href ? href.replace(
    ZIPCODE_QUERY_PARAM,
    ZIPCODE_QUERY_PARAM + deliveryLocation.zipCode
  ) : href;
  return /* @__PURE__ */ jsx("a", { className, href: samedayLink, target: props.target, children: props.children });
};
export {
  SameDay
};
